import React from 'react';

// A8: Meko onayında karşı tarafa serbest açıklama gitmez. Teklif/davet; proje, etkinlik türü, kişi sayısı ve tarih gibi
// yapılandırılmış alanlardan sunucuda hazırlanan sabit metinle gider. Bu bileşen yalnız açık onay düğmesini gösterir.
const TEXTS = {
  venue: {
    label: 'Organizatöre gidecek davet',
    help: 'Organizatöre yalnız hazır davet metni gider: etkinlik türü, kişi sayısı ve koşullar. Serbest mesaj eklenmez; ayrıntıları sonra hazır soru-cevapla netleştirirsiniz.',
    submit: 'Onayla ve daveti gönder',
  },
  organizer: {
    label: 'Mekâna gidecek teklif',
    help: 'Mekâna yalnız hazır teklif metni gider: proje, etkinlik türü, kişi sayısı ve tarih. Serbest mesaj eklenmez; ayrıntıları sonra hazır soru-cevapla netleştirirsiniz.',
    submit: 'Onayla ve başvuruyu gönder',
  },
};

export default function ApplicationMessage({ disabled, onConfirm, role = 'organizer' }) {
  const text = TEXTS[role] || TEXTS.organizer;
  return <form className="chat-application-message" data-testid="chat-offer-confirm" onSubmit={event => { event.preventDefault(); if (!disabled) onConfirm(''); }}>
    <p className="font-semibold" id="application-message-label">{text.label}</p>
    <p id="application-message-help">{text.help}</p>
    <button type="submit" className="action-primary" disabled={disabled} aria-describedby="application-message-help">{text.submit}</button>
  </form>;
}
